import { fetchQuestionAnswers } from '../../services/questionAnswers';
import { TThunkAction } from '../../types/redux';
import { addAnswersToQuestion } from '../questions';
import { setAnswers } from './actions';

interface IParams {
  questionId: string;
  page: number;
}

export function loadQuestionAnswers({ questionId, page }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const { answers, answerIds, hasMore } = await fetchQuestionAnswers({
        httpApi,
        parameters: { page, questionId },
      });

      dispatch(setAnswers(answers));
      dispatch(addAnswersToQuestion({ answerIds, questionId, hasMore, answersPage: page }));

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'question#loadQuestionAnswers',
        message: error.message,
      });

      return false;
    }
  };
}
